import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Spin } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ServiceTemplateForm } from "./serviceTemplateForm.js";
import { useFormValidation } from "../../../../../hooks/form/useFormValidation.js";
import { useServiceTemplateByIdentifier } from "../../../../../hooks/service/useServiceTemplate.js";
import { useServiceTemplateEdit } from "../../../../../hooks/service/useServiceTemplateEdit.js";
import { useTranslation } from "../../../../../others/i18n.js";
import { useStores } from "../../../../../store/root.js";
function ServiceTemplateEdit(props) {
    const { t } = useTranslation();
    const { notificationStore } = useStores();
    const { modalModeOptions } = props;
    let { identifier } = useParams();
    identifier = identifier || modalModeOptions?.editIdentifier;
    const navigate = useNavigate();
    const [templateForm] = Form.useForm();
    const [validationErrors, setValidationErrors] = useState(undefined);
    useFormValidation(templateForm, validationErrors);
    const [serviceTemplate, setServiceTemplate] = useState(undefined);
    const useServiceTemplate = useServiceTemplateByIdentifier(identifier);
    useEffect(()=>{
        const { data, isError, isFetched } = useServiceTemplate;
        if (isFetched) {
            if (data) {
                setServiceTemplate(data);
            } else if (isError) {
                navigate("/rcb/service");
            }
        }
    }, [
        useServiceTemplate.data,
        useServiceTemplate.isError,
        useServiceTemplate.isFetched
    ]);
    const [serviceTemplateToEdit, setServiceTemplateToEdit] = useState(undefined);
    const useUpdateServiceTemplate = useServiceTemplateEdit(serviceTemplateToEdit);
    useEffect(()=>{
        const { data, error, isError, isFetching, isSuccess, isLoading } = useUpdateServiceTemplate;
        if (isFetching || isLoading) {
            return;
        }
        if (isSuccess && data && !isNaN(Number(data.id))) {
            notificationStore.clearAll();
            setServiceTemplateToEdit(undefined);
            setValidationErrors(undefined);
            setServiceTemplate(undefined);
            useServiceTemplate.refetch();
            notificationStore.add({
                type: "success",
                message: t("Template updated!"),
                closable: true,
                duration: 3
            });
            modalModeOptions?.onAfterSave?.();
        } else if (isError && error) {
            notificationStore.clearAll();
            setValidationErrors(error);
            notificationStore.addFromServerError(error, t);
        }
    }, [
        useUpdateServiceTemplate,
        serviceTemplateToEdit
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Breadcrumb, {
                items: [
                    {
                        href: "/rcb",
                        title: /*#__PURE__*/ _jsx(HomeOutlined, {})
                    },
                    {
                        href: "/rcb/service",
                        title: /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(UserOutlined, {}),
                                /*#__PURE__*/ _jsx("span", {
                                    children: t("Services")
                                })
                            ]
                        })
                    },
                    {
                        title: t("Edit")
                    }
                ]
            }),
            serviceTemplate ? /*#__PURE__*/ _jsx(ServiceTemplateForm, {
                isLoading: useUpdateServiceTemplate.isFetching,
                serviceTemplate: serviceTemplate,
                templateForm: templateForm,
                onSubmit: (formTemplate, currentTemplate)=>{
                    formTemplate["_lastSubmit"] = new Date().getTime();
                    formTemplate.id = currentTemplate.id; // set here, because it's lost in form
                    setServiceTemplateToEdit(formTemplate);
                },
                isModalView: !!modalModeOptions
            }) : /*#__PURE__*/ _jsx("div", {
                style: {
                    height: "800px",
                    width: "100%"
                },
                children: /*#__PURE__*/ _jsx(Spin, {
                    size: "large",
                    style: {
                        position: "fixed",
                        left: "50%",
                        top: "50%"
                    },
                    spinning: true
                })
            })
        ]
    });
}
export { ServiceTemplateEdit };
